<div class="router-event">
    <!-- Guardado en curso: bloquea la pantalla para que no se pueda volver a
         pulsar el botón (publicar genera las reservas de los abonados y tarda). -->
    <div class="saving-overlay" *ngIf="savingEvent">
        <div class="saving-box">
            <ng-lottie class="saving-lottie" [options]="{path: 'assets/lotties/loading.json'}"></ng-lottie>
            <p class="saving-text m-0">{{ savingMessage }}</p>
        </div>
    </div>

    <ng-container *ngIf="!embedded">
        <div class="d-flex align-items-end justify-content-between">
            <h1 class="title-detail-event m-0">Crear evento</h1>
            <div class="d-block d-lg-flex align-items-center link-open-event" (click)="openLinkEvent()">
                <i class="fal fa-eye pointer-in"></i>
                <span>Previsualizar en Citylok</span>
            </div>
        </div>
        <mat-divider class="divider-title"></mat-divider>
    </ng-container>

    <div class="margin-steps">

        <!-- Card: Tipo de evento (en edición, solo junto con "Información del evento") -->
        <div class="create-card" *ngIf="isSectionVisible('info-event')">
            <div class="create-card-header" [class.section-toggle]="!embedded" (click)="toggleSection('event-type')">
                <i class="fal fa-layer-group create-card-icon"></i>
                <h3 class="create-card-title">Tipo de evento</h3>
                <div class="ms-auto d-flex align-items-center gap-2">
                    <span class="event-type-selected-badge" *ngIf="eventType">
                        <i class="fal"
                            [class.fa-ticket]="eventType === 'normal'"
                            [class.fa-circle-info]="eventType === 'informative'"
                            [class.fa-arrow-up-right-from-square]="eventType === 'external'"></i>
                        {{ eventType === 'normal' ? 'Evento con venta de entradas' : (eventType === 'informative' ? 'Evento informativo' : 'Venta externa') }}
                    </span>
                    <i class="fal fa-chevron-down section-chevron" *ngIf="!embedded"
                        [class.chevron-open]="openSections['event-type']"></i>
                </div>
            </div>
            <div *ngIf="openSections['event-type'] && !embedded" class="create-card-body" [@slideDown]>
                <p class="event-type-subtitle">Elige el modelo que mejor se adapta a tu evento.</p>
                <p class="create-hint" *ngIf="embedded">El tipo de evento no se puede cambiar una vez creado el evento.</p>
                <div class="event-type-cards" [class.card-disabled]="embedded">
                    <div class="event-type-card" [class.active]="eventType === 'normal'" (click)="selectEventType('normal')">
                        <div class="event-type-card-icon">
                            <i class="fal fa-ticket"></i>
                        </div>
                        <p class="event-type-card-name">Evento con venta de entradas</p>
                        <p class="event-type-card-desc">La venta de entradas se gestiona dentro de Citylok. Podrás configurar entradas, aforo y configuración de venta.</p>
                        <div class="event-type-card-cta">Seleccionar <i class="fal fa-arrow-right"></i></div>
                    </div>
                    <div class="event-type-card" [class.active]="eventType === 'informative'" (click)="selectEventType('informative')">
                        <div class="event-type-card-icon">
                            <i class="fal fa-circle-info"></i>
                        </div>
                        <p class="event-type-card-name">Evento informativo</p>
                        <p class="event-type-card-desc">El evento solo muestra información, sin venta de entradas. Se mostrará con una etiqueta "+ INFO".</p>
                        <div class="event-type-card-cta">Seleccionar <i class="fal fa-arrow-right"></i></div>
                    </div>
                    <div class="event-type-card" [class.active]="eventType === 'external'" (click)="selectEventType('external')">
                        <div class="event-type-card-icon">
                            <i class="fal fa-arrow-up-right-from-square"></i>
                        </div>
                        <p class="event-type-card-name">Venta externa</p>
                        <p class="event-type-card-desc">La venta de entradas se gestiona fuera de Citylok. Los usuarios serán redirigidos a la URL que indiques.</p>
                        <div class="event-type-card-cta">Seleccionar <i class="fal fa-arrow-right"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Secciones del formulario de creación -->
        <div class="create-event-wrapper" [class.card-disabled]="!eventType" *ngIf="isSectionVisible('info-event') && eventDataLoaded">
            <app-create-event
                [eventType]="eventType"
                [idEvent]="idEvent"
                [onlyCard]="onlyCard"
                [embedded]="embedded"
                (changePlaceEmit)="changePlace($event)"
                (changeTab)="changeMenuEvent($event)">
            </app-create-event>
        </div>

        <!-- Fechas y sesiones -->
        <div class="create-card" [class.card-disabled]="!eventType" *ngIf="isSectionVisible('sessions-event')">
            <div id="section-sessions-event" class="create-card-header section-toggle" (click)="toggleSection('sessions-event')">
                <i class="fal fa-calendar-days create-card-icon"></i>
                <h3 class="create-card-title">Sesiones <span class="required-field">*</span></h3>
                <div class="ms-auto d-flex align-items-center gap-2">
                    <i class="fal fa-check-circle check-icon check-green" *ngIf="validSessions && !embedded"></i>
                    <i class="fal fa-chevron-down section-chevron"
                        [class.chevron-open]="openSections['sessions-event']"></i>
                </div>
            </div>
            <div *ngIf="isSectionOpen('sessions-event') && eventDataLoaded" style="padding: 0;" [@slideDown]>
                <app-sessions-event [idEvent]="idEvent" (changeTab)="changeMenuEvent($event)"></app-sessions-event>
            </div>
        </div>

        <!-- Entradas (solo evento normal o sin seleccionar) -->
        <div class="create-card" *ngIf="(!eventType || eventType === 'normal') && isSectionVisible('ticket-event')" [class.card-disabled]="!eventType">
            <div id="section-ticket-event" class="create-card-header section-toggle" (click)="toggleSection('ticket-event')">
                <i class="fal fa-ticket create-card-icon"></i>
                <h3 class="create-card-title">Entradas <span class="required-field">*</span></h3>
                <div class="ms-auto d-flex align-items-center gap-2">
                    <i class="fal fa-check-circle check-icon check-green" *ngIf="validTickets && !embedded"></i>
                    <i class="fal fa-chevron-down section-chevron"
                        [class.chevron-open]="openSections['ticket-event']"></i>
                </div>
            </div>
            <div *ngIf="isSectionOpen('ticket-event') && eventDataLoaded" [@slideDown]>
                <app-tickets-create [loadingTickets]="loadingTickets" [numTickets]="numTickets" (changeTab)="changeMenuEvent($event)" [sessions]="sessions"></app-tickets-create>
            </div>
        </div>

        <!-- Configuración de venta (solo evento normal o sin seleccionar) -->
        <div class="create-card" *ngIf="(!eventType || eventType === 'normal') && isSectionVisible('sale-config-event')" [class.card-disabled]="!eventType">
            <div id="section-sale-config-event" class="create-card-header section-toggle" (click)="toggleSection('sale-config-event')">
                <i class="fal fa-sliders create-card-icon"></i>
                <h3 class="create-card-title">Configuración de venta</h3>
                <div class="ms-auto d-flex align-items-center gap-2">
                    <span class="nominative-badge" *ngIf="isNominativeEvent">
                        <i class="fal fa-id-card"></i>
                        Nominativas
                    </span>
                    <i class="fal fa-chevron-down section-chevron"
                        [class.chevron-open]="openSections['sale-config-event']"></i>
                </div>
            </div>
            <div *ngIf="isSectionOpen('sale-config-event') && eventDataLoaded" [@slideDown]>
                <app-sale-config-create [idEvent]="idEvent" [configTickets]="configTickets" [embedded]="embedded" (changeTab)="changeMenuEvent($event)"></app-sale-config-create>
            </div>
        </div>

        <div class="buttons-wrapper" *ngIf="eventType">
            <div class="buttons-actions">
                <div class="btn-create btn-publish m-0" *ngIf="!isPublished" [class.btn-disabled]="!canPublish || savingEvent" (click)="saveEvent(true)">
                    <i class="fal" [class.fa-paper-plane-top]="!savingEvent" [class.fa-spinner-third]="savingEvent" [class.fa-spin]="savingEvent"></i>
                    <p class="m-0">{{ savingEvent ? 'Publicando…' : 'Publicar evento' }}</p>
                </div>
                <div class="btn-create btn-create-border m-0" *ngIf="hasUnsavedChanges" [@popIn] [class.btn-disabled]="savingEvent" (click)="saveEvent()">
                    <i class="fal" [class.fa-save]="!savingEvent" [class.fa-spinner-third]="savingEvent" [class.fa-spin]="savingEvent"></i>
                    <p class="m-0">{{ savingEvent ? 'Guardando…' : 'Guardar cambios' }}</p>
                </div>
            </div>
            <!-- Solo al editar un evento existente, en la pantalla "Información del evento": eliminar / despublicar / desactivar -->
            <button class="btn-icon-delete" *ngIf="idEvent && currentStep === 'info-event'" (click)="inactiveEvent()" matTooltip="Eliminar evento">
                <i class="fal fa-trash-alt"></i>
            </button>
        </div>

    </div>
</div>
